<template>
    <v-container>
        <v-card>
            <v-card-text>
                <h4 class="primary--text">{{$route.params.id?'Edit':'Create'}} User</h4>
                <v-form>
                    <v-text-field type="text" :label="$t('lang.user.username')" v-model.trim="user.userName"
                                  name="userName"
                                  v-validate="'required|alpha_num|max:50|usernameUnique'"
                                  :data-vv-as="$t('lang.user.username')"
                                  maxLength="20" autofocus :disabled="user.userId>0"
                                  :error-messages="errors.first('userName')"
                    ></v-text-field>
                  <v-text-field type="text" :label="$t('lang.user.code')" v-model.trim="user.userCode"
                                name="userCode"
                                :data-vv-as="$t('lang.user.code')"
                                 autofocus
                                :error-messages="errors.first('userCode')"
                  ></v-text-field>

                    <v-text-field type="password" ref="password" :label="$t('lang.user.password')"
                                  v-model.trim="user.password"
                                  name="password" v-validate="user.id?'min:8':'min:8'"
                                  :data-vv-as="$t('lang.user.password')"
                                  maxLength="20"
                                  :error-messages="errors.first('password')"
                    ></v-text-field>

                    <v-text-field type="password" :label="$t('lang.user.retypePassword')"
                                  v-model.trim="user.passwordConf" name="passwordConf"
                                  v-validate="user.id?'confirmed:password':'|confirmed:password'"
                                  :data-vv-as="$t('lang.user.retypePassword')"
                                  ref="passwordConf"
                                  :error-messages="errors.first('passwordConf')"
                    ></v-text-field>

                    <v-text-field type="text" :label="$t('lang.user.email')" v-model.trim="user.email" name="email"
                                  v-validate="user.id?'required|email|emailUnique':'required|email|emailUnique'"
                                  :data-vv-as="$t('lang.user.email')"
                                  maxLength="50"

                                  :error-messages="errors.first('email')"
                    ></v-text-field>

                    <v-text-field type="text" :label="$t('lang.user.fullName')" v-model.trim="user.fullName"
                                  name="fullName"
                                  v-validate="'required'" maxLength="50"
                                  :data-vv-as="$t('lang.user.fullName')"
                                  :error-messages="errors.first('fullName')"
                    ></v-text-field>

                    <!-- <v-text-field type="text" label="Phone*" v-model="user.phone" name="phone" v-validate="'required'" mask="(###) ### - ####" maxLength="20"
                    :error-messages="errors.first('phone')"
                    ></v-text-field> -->

                    <v-text-field type="text" :label="$t('lang.user.phone')" v-model.trim="user.phone" name="phone"
                                  v-validate="{ required: true, regex: /^[0-9()-]*$/im }" maxLength="20"
                                  :data-vv-as="$t('lang.user.phone')"
                                  :error-messages="errors.first('phone')"
                    ></v-text-field>

                    <v-checkbox v-model="user.status" :label="$t('lang.user.status')" name="status" type="checkbox"
                                :data-vv-as="$t('lang.user.status')"
                                :false-value="0"
                                :true-value="1"
                                :error-messages="errors.first('status')"
                    ></v-checkbox>


                    <v-select :items="countryIds" :label="$t('lang.user.country')"
                              v-model="user.countryId" name="countryId"
                              item-value="code"
                              item-text="name"
                              v-validate="'required'"
                              :data-vv-as="$t('lang.user.country')"
                              :error-messages="errors.first('countryId')"

                    />

                    <v-select :items="roleList" :label="$t('lang.user.role')" v-model="user.role" name="role"
                              item-text="roleName" item-value="id" v-validate="'required'"
                              :data-vv-as="$t('lang.user.role')"

                              :error-messages="errors.first('role')"
                    >
                    </v-select>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="handleSubmit">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="error" dark @click="back">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {router} from "../../router";
    import {mapState} from "vuex";
    import {Validator} from "vee-validate";
    import {CrudService} from "@/services";
    import {roleService} from "@/services";
    import axios from "axios";
    import {message} from "@/shared/message";

    export default {
        name: "UserEdit",
        data() {
            return {
                submitted: false,
                user: {
                    status: 1
                },
                countryIds: [],
            };
        },
        computed: mapState({
            loading: state => state.common.loading,
            roleList: state => state.role.roleList.filter(function (value) {
                console.log(value);
                return value.active == 1;
            })
        }),
        methods: {
            handleSubmit(e) {
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {

                        if (this.$route.params.id) {
                            CrudService.of('user').updateItem(this.user).then(() => {
                                message.success(`Update User Success!`, '/user/list');
                            });
                        } else {
                            CrudService.of('user').createItem(this.user).then(() => {
                                message.success(`Create User Success!`, '/user/list');
                            });
                        }
                    }
                });
                return false;
            },
            back() {
                router.push("/user/list");
            }
        },
        created() {
            this.$store.dispatch("role/getRoleList");
            if (this.$route.params.id) {
                CrudService.of('user').getItem(this.$route.params.id).then(user => {
                    user.password = "";
                    //debugger;
                    let userTmp = JSON.parse(
                        localStorage.getItem("user") === "undefined"
                            ? null
                            : localStorage.getItem("user")
                    );
                    if (userTmp.username != "admin" && user.username == "admin") {
                        message.error("Can not modify admin account!");
                        router.push("/user/list");
                    }
                    this.user = user;
                    this.initUsername = user.userName;
                    this.initEmail = user.email;
                });

            }
            axios.get(process.env.VUE_APP_API_URL + "/selectboxdata/country", {}).then(
                data => {
                    this.countryIds = data.items

                }
            )
        },
        mounted() {
            let me = this;
            const usernameUnique = (value) => {
                if (me.initUsername == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-username?username=${value}`).then((data) => {
                    //debugger;
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });

            };

            const emailUnique = (value) => {
                if (me.initEmail == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/user/validate-email?email=${value}`).then((data) => {
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });
            };

            Validator.extend("usernameUnique", {
                validate: usernameUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.user.usernameExist');
                }
            });

            Validator.extend("emailUnique", {
                validate: emailUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.user.emailExist');
                }
            });

            if (this.$route.params.id) {
                this.$refs.password.focus();
            }
        }
    };
</script>
